import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { colors } from '../constants/moderation';

export default class ModerationHistory extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId, attendeeId }) {
        if (!organizationId) {
            throw new Error('[ModerationHistory] OrganizationId is mandatory');
        }
        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/attendees/${attendeeId}/moderation_logs`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/attendees/${attendeeId}/moderation_logs`;
    }

    static replay({ organizationId, flowId, id, data }) {
        let url = `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/moderation_logs/${id}/replay_action`;

        if (!flowId) {
            url = `/ticket/organizations/${organizationId}/moderation_flows/moderation_logs/${id}/replay_action`;
        }

        return fetcher.post(url, {
            data: { action: data }
        });
    }

    static revert({ organizationId, flowId, id, data }) {
        let url = `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/moderation_logs/${id}/revert_action`;

        if (!flowId) {
            url = `/ticket/organizations/${organizationId}/moderation_flows/moderation_logs/${id}/revert_action`;
        }

        return fetcher.post(url, {
            data: { action_log: data }
        });
    }

    get name() {
        return this.object?.user?.full_name || '';
    }

    get status() {
        return this.object.destination_status?.name || '';
    }

    get color() {
        return colors[this.object.destination_status.stage];
    }

    get isSpamLog() {
        return false;
    }
}
